export default __webpack_public_path__ + "static/media/pixellab--web-design--04a--600x450.6c2204fd.jpg";